import Link from 'next/link'
import { NextSeo } from 'next-seo'
import styled from 'styled-components'
import DefaultPageLayout from '~/components/templates/DefaultPageLayout'

export default function HelpPage() {
  const contactForm =
    'https://docs.google.com/forms/d/e/1FAIpQLScvp93natLwhQt3G-O3i2-irVm3DU1mAxNpdjiLYByeKugE5w/viewform'

  return (
    <DefaultPageLayout>
      <NextSeo
        title='よくある質問'
        openGraph={{
          url: `${process.env.origin}/help`,
          title: 'よくある質問 - Ambass'
        }}
      />
      <Title>ヘルプ</Title>
      <Container>
        <Row>
          <Links>
            <StyledLink href='/terms' passHref>
              利用規約
            </StyledLink>
            <StyledLink href='/policy' passHref>
              プライバシーポリシー
            </StyledLink>
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
          </Links>
        </Row>
        <Header>サービスについて</Header>
        <Row>
          <Question>Ambassとはなんですか？</Question>
          <Answer>
            Ambass（アンバス）はクリエイターのデジタル作品を購入・布教できる。ギフティングプラットフォームです。クリエイターのファンがアンバサダーとなることで、推しのクリエイターの作品がより多くの人々に広まることを目指しています。
          </Answer>
        </Row>
        <Row>
          <Question>アンバサダーとはなんですか？</Question>
          <Answer>
            クリエイターの活動を支え、貢献したことを示す称号です。クリエイターの作品を布教用に購入するとアンバサダーになることができます。推しのクリエイターの作品をたくさん布教して、アンバサダーの輪を広げていってください。
          </Answer>
        </Row>
        <Row>
          <Question>初期費用や月額利用料はかかりますか？</Question>
          <Answer>
            Ambassの利用にあたって、初期費用・月額利用料は発生しません。ただし、作品が購入された際には、クリエイターの売上の一部を決済代行会社への手数料・サービス運営費用としていただきます。
          </Answer>
        </Row>
        <Row>
          <Question>利用にあたって年齢制限はありますか？</Question>
          <Answer>
            Ambassは、20歳以上の方のみご利用いただけます。
            ただし、20歳未満でも親権者の同意があった場合はご利用いただけます。
          </Answer>
        </Row>
        <Row>
          <Question>利用にあたって推奨するブラウザは何ですか？</Question>
          <Answer>サポート対象のブラウザは以下の通りです。</Answer>
          <Answer>
            GoogleChrome最新版
            <br />
            <StyledAnchor
              href='https://www.google.com/chrome'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://www.google.com/chrome
            </StyledAnchor>
          </Answer>
          <Answer>
            Safari最新版
            <br />
            <StyledAnchor
              href='https://www.apple.com/jp/safari/'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://www.apple.com/jp/safari/
            </StyledAnchor>
          </Answer>
          <Answer>
            Edge最新版
            <br />
            <StyledAnchor
              href='https://www.microsoft.com/ja-jp/edge'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://www.microsoft.com/ja-jp/edge
            </StyledAnchor>
          </Answer>
        </Row>
        <Row>
          <Question>利用できる端末は何ですか？</Question>
          <Answer>
            パソコン、スマートフォン、またはタブレット端末からご利用いただけます。
            フィーチャーフォン・ゲーム機のブラウザアプリなどには対応しておりませんのでご注意くださいませ。
          </Answer>
        </Row>
        <Header>アカウントについて</Header>
        <Row>
          <Question>X連携以外でユーザー登録できますか？</Question>
          <Answer>
            現状対応しているのはX連携による登録のみとなっております。他の認証方法によるユーザー登録・ログインに関しては、開発優先度なども考慮して検討していきます。
          </Answer>
        </Row>
        <Row>
          <Question>ユーザー登録が出来ません</Question>
          <Answer>
            すでにお使いのIDが利用されているなどの原因が考えられます。運営で原因を調査しますので、お手数ですが
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
            からご連絡くださいませ。
          </Answer>
        </Row>
        <Row>
          <Question>
            連携していたXアカウントにログインできなくなり、Ambassが使えなくなってしまいました
          </Question>
          <Answer>
            Xにお問い合わせして原因・対処法をご確認ください。
            <br />
            <StyledAnchor
              href='https://help.twitter.com/ja/contact-us'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://help.twitter.com/ja/contact-us
            </StyledAnchor>
          </Answer>
        </Row>
        <Row>
          <Question>退会したいのですがどのようにすればよいですか？</Question>
          <Answer>
            運営で対応いたしますので、お手数ですが
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
            からご連絡くださいませ。
          </Answer>
          <Answer>
            ただし、以下の場合は退会ができません。それぞれ各自で対応してからお問い合わせをお願いします。
          </Answer>
          <List>
            <ListContainer>払込処理の終わっていない振込申請がある場合</ListContainer>
            <ListContainer>受取可能な布教リンクを所有している場合</ListContainer>
          </List>
        </Row>
        <Row>
          <Question>メールが届きません</Question>
          <Answer>
            現在お使いのメールアドレスが正しく設定されているかプロフィール編集ページからご確認ください。
          </Answer>
          <Answer>
            また、迷惑メール対策などでドメイン指定受信を設定している場合に、メールが正しく届かないことがございます。「@ambass.me」ドメインからのメールを受信できるようにしてください。
          </Answer>
        </Row>
        <Row>
          <Question>クレジットカードの登録ができません</Question>
          <Answer>
            クレジットカード番号や有効期限などの登録内容に不備がある場合、登録が失敗します。すべての内容が正しく入力されているか、再度ご確認ください。
          </Answer>
          <Answer>
            正しく入力されているにもかかわらず登録できない場合は、こちらで原因を特定できませんので、お手数ですがクレジットカード発行会社にお問い合わせください。
          </Answer>
        </Row>
        <Header>作品の販売について</Header>
        <Row>
          <Question>Ambassではどういう商品を販売できますか？</Question>
          <Answer>
            Ambassでは、イラスト・ゲーム・音楽・音声作品・電子書籍などのさまざまな創作物をデジタルコンテンツとして販売できます。現在対応してるファイルはzip形式で300MBまでとなっておりますが、その他のファイル形式や容量の増加などクリエイターからのご要望がありましたら、対応を検討していきますので
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
            からお送りくださいませ。
          </Answer>
          <Answer>
            販売を禁止されている作品に関しては、
            <StyledLink href='/terms' passHref>
              利用規約
            </StyledLink>
            の第8条からご確認ください。
          </Answer>
        </Row>
        <Row>
          <Question>どうすればコンテンツを販売できますか？</Question>
          <Answer>
            作品登録ページから作品を登録するだけで販売を開始することが出来ます。作品の登録には登録料はかかりません。
          </Answer>
        </Row>
        <Row>
          <Question>
            クリエイターページや作品ページのURLをXでシェアすると古い商品画像が表示されます
          </Question>
          <Answer>
            X社の保持しているキャッシュが表示されている可能性があります。X社の提供している
            CardValidatorを使用し、キャッシュをクリアしていただきますようお願いします。
            <br />
            <StyledAnchor
              href='https://cards-dev.twitter.com/validator'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://cards-dev.twitter.com/validator
            </StyledAnchor>
          </Answer>
        </Row>
        <Row>
          <Question>作品ファイルを差し替えることが出来ますか？</Question>
          <Answer>
            それぞれの作品の編集ページで、差し替えることができます。なお差し替えを行なった場合、過去の購入者も差し替える前のファイルはダウンロードできなくなり、差し替わった最新のファイルをダウンロードできるようになります。
          </Answer>
          <Answer>
            ファイルの変更・削除する場合は、トラブルを避けるため、事前に購入者へのアナウンスを推奨しております。
          </Answer>
        </Row>
        <Row>
          <Question>売上にかかるサービス利用料はいくらですか？</Question>
          <Answer>
            販売価格から決済手数料とプラットフォーム手数料合計10％が差し引かれた額が売上となります。
          </Answer>
        </Row>
        <Row>
          <Question>売上金はいつ受け取ることができますか？</Question>
          <Answer>
            作品が購入され、売上金を獲得した後でしたら、任意のタイミングで受け取りが可能です。売上管理ページから振込申請を行い、売上金をお受取りください。振込申請を行ったタイミングでストックされている売上金をすべてお振込させていただきます。
          </Answer>
          <Answer>なお、振込申請1回ごとに振込手数料として300円徴収させていただきます。</Answer>
        </Row>
        <Row>
          <Question>
            作品を公開停止・削除にした場合、過去に購入したユーザーはファイルをダウンロードできますか？
          </Question>
          <Answer>
            作品を公開停止・削除にした場合、新規・追加の購入はできなくなります。ただし、過去購入したユーザーは引き続きダウンロードを行うことができます。過去の購入者もダウンロードできなくする場合は、作品ファイル差し替えと同様に、事前に購入者へのアナウンスをした上でファイルを削除するなどご対応いただければと思います。
          </Answer>
        </Row>
        <Row>
          <Question>振込先の口座には海外の口座も利用できますか？</Question>
          <Answer>
            日本国内の銀行口座のみ対応となります。日本国内の銀行口座を持っていないお客様には、PayPalなどの送金サービスを用いて対応させていただきます。
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
            から送金の旨をお伝えくださいませ。
          </Answer>
        </Row>
        <Row>
          <Question>売上の振り込み後に連絡はありますか？</Question>
          <Answer>
            振込申請を行ったタイミングで確認のメールを送りますが、振り込み後の連絡は行っておりません。なお、申請を行った銀行口座の情報が誤っているなどで振込に失敗した際にはご連絡させていただきます。5営業日以内に（土日祝除く）入金の確認ができない、もしくは失敗の通知がない場合は
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
            から入金が確認できない旨をお伝えくださいませ。
          </Answer>
        </Row>
        <Row>
          <Question>特定商取引法に基づく表記とは何ですか？</Question>
          <Answer>
            特定商取引に関する法律（以下、「特定商取引法」）は、訪問販売や通信販売など消費者トラブルを生じやすい特定の取引類型を対象に、トラブル防止のルールを定め、事業者による不公正な勧誘行為等を取り締まることにより、消費者取引の公正を確保するための法律です。インターネット上で通信販売を行う方は、自身のショップで特定商取引法上必要な表記事項を明記する必要があります。
          </Answer>
        </Row>
        <Row>
          <Question>連絡先や、売上の振込先が公開されることはありますか？</Question>
          <Answer>
            クリエイターの連絡先や売上の振込先は、運営がプライバシーポリシーに則り、管理します。クリエイターの同意なく、第三者に提供されることはありません。
          </Answer>
        </Row>
        <Header>作品の購入について</Header>
        <Row>
          <Question>NSFWコンテンツとは何ですか？</Question>
          <Answer>
            NSFWはNotSafeforWorkの略称で、フォーマルな場や公共での視聴が不適切だと考えられるコンテンツに指定されます。ユーザー登録時は表示がOFFになっております。
          </Answer>
        </Row>
        <Row>
          <Question>「布教用に購入」とは何ですか？</Question>
          <Answer>
            他人に布教するために作品を購入します。「布教用に購入」すると布教リンクが発行され、布教リンクを共有することで他人に作品をプレゼントすることができ、クリエイターの新たなファンの獲得につなげます。
          </Answer>
        </Row>
        <Row>
          <Question>「布教用リンクを有効」とは何ですか？</Question>
          <Answer>
            布教用に作品を購入すると得られる布教リンクは一時的に無効にすることも出来ます。無効の間は布教リンクが共有されても、作品を受け取ることができなくなります。
          </Answer>
        </Row>
        <Row>
          <Question>「追加で購入」とは何ですか？</Question>
          <Answer>
            Ambassでは布教用に同じ作品を複数購入して布教することが出来ます。追加で購入すると、それぞれの作品の布教リンクで受け取れる回数が増えます。例えば作品を5人に配りたい時は5部購入し、布教したい5人に同じリンクを共有してください。
          </Answer>
        </Row>
        <Row>
          <Question>「自分用に購入」とは何ですか？</Question>
          <Answer>
            ご自分で楽しむために作品を購入します。「自分用に購入」すると作品のダウンロードリンクが現れますので、そちらからダウンロードして作品をお楽しみください。
          </Answer>
        </Row>
        <Row>
          <Question>
            自分用に購入した作品・他人から布教された作品はどのように閲覧できますか？
          </Question>
          <Answer>
            「自分用に購入」もしくは、他人から共有された布教リンクから作品を受け取ると、作品ページにダウンロードリンクが現れます。そちらからダウンロードして作品をお楽しみください。
          </Answer>
          <Answer>
            また、ライブラリページから自分用に購入した作品・他人から布教された作品を一覧で閲覧することが可能です。
          </Answer>
        </Row>
        <Row>
          <Question>購入したのにダウンロードが出来ません</Question>
          <Answer>
            「布教用に購入」した作品は、他人への布教用なのでダウンロードは出来ません。自分用に購入する、もしくは他人から布教リンクを受け取って作品をお楽しみください。
          </Answer>
        </Row>
        <Row>
          <Question>ダウンロードしたzipファイルの開き方がわかりません</Question>
          <Answer>
            zipはファイルを圧縮したファイル形式です。開く前に解凍する必要があります。ご利用いただいている端末によって、解凍の方法が異なりますのでそれぞれご確認ください。
          </Answer>
          <Answer>
            iOS端末
            <br />
            <StyledAnchor
              href='https://support.apple.com/ja-jp/HT211132'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://support.apple.com/ja-jp/HT211132
            </StyledAnchor>
          </Answer>
          <Answer>
            Android端末
            <br />
            <StyledAnchor
              href='https://support.google.com/files/answer/9048509?hl=ja'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://support.google.com/files/answer/9048509?hl=ja
            </StyledAnchor>
          </Answer>
          <Answer>
            Windows端末
            <br />
            <StyledAnchor
              href='https://support.microsoft.com/ja-jp/windows/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E3%82%92%E5%9C%A7%E7%B8%AE%E3%81%8A%E3%82%88%E3%81%B3%E5%B1%95%E9%96%8B%E3%81%99%E3%82%8B-8d28fa72-f2f9-712f-67df-f80cf89fd4e5'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://support.microsoft.com/ja-jp/windows/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E3%82%92%E5%9C%A7%E7%B8%AE%E3%81%8A%E3%82%88%E3%81%B3%E5%B1%95%E9%96%8B%E3%81%99%E3%82%8B-8d28fa72-f2f9-712f-67df-f80cf89fd4e5
            </StyledAnchor>
          </Answer>
          <Answer>
            Mac端末
            <br />
            <StyledAnchor
              href='https://support.apple.com/ja-jp/guide/mac-help/mchlp2528/mac'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://support.apple.com/ja-jp/guide/mac-help/mchlp2528/mac
            </StyledAnchor>
          </Answer>
        </Row>
        <Row>
          <Question>商品価格は税込みですか？税抜きですか？</Question>
          <Answer>商品価格は、すべて消費税が含まれた価格となっております。</Answer>
        </Row>
        <Row>
          <Question>利用できる決済手段はどんな種類がありますか？</Question>
          <Answer>
            現在、クレジットカード決済にのみ対応しております。その他の決済手段についても導入を検討しておりますが、キャリア決済などは手数料が高くクリエイターの売上が減ってしまうので慎重に導入を検討していきます。クレジットカード形式のプリペイドカードでしたら利用が可能です。現在はプリペイドカードを簡単に作れるサービスがいくつかありますので、そちらを使うなどご協力いただければと思います。
          </Answer>
        </Row>
        <Row>
          <Question>利用できるクレジットカードはどんな種類がありますか？</Question>
          <Answer>
            Visa、Mastercard、AmericanExpress、Discover、DinersClub、JCBに対応しております。その他クレジットカード形式のプリペイドカードでも決済が可能です。上記にあげたカードがご利用できない場合は、運営で確認が取れませんのでクレジットカードの発行会社に直接お問い合わせくださいませ。
          </Answer>
        </Row>
        <Row>
          <Question>作品の説明内容とダウンロードした作品の内容が異なっていました</Question>
          <Answer>
            作品を購入したクリエイターにご連絡くださいませ。運営では個別の問題についての責任をとりかねますので、ご連絡いただいても直接問題の解決を図る、また補償をすることができません。
          </Answer>
        </Row>
        <Row>
          <Question>間違って商品を購入してしまいました</Question>
          <Answer>
            Ambassでは、ユーザーのご都合によるキャンセル・返金はお受けすることが出来ません。購入前によく内容を確認の上、ご購入くださいませ。
          </Answer>
        </Row>
        <Row>
          <Question>
            作品をまだ購入していないのに、クレジットカードの支払いが発生しました。なぜですか？
          </Question>
          <Answer>
            セキュリティーの都合上、クレジットカードの種類によって認証前に少額の決済を必要とする場合がございます。すぐに返金されますのでご安心ください。
          </Answer>
        </Row>
        <Row>
          <Question>違反商品を見つけました</Question>
          <Answer>
            <StyledAnchor href={contactForm} target='_blank' rel='noopener noreferrer'>
              お問い合わせ
            </StyledAnchor>
            より、該当する商品ページのURLと違反事項についてご報告ください。転載画像等が使用されている可能性のある商品の場合は、転載元のURLなども併せてご報告ください。
          </Answer>
        </Row>
        <Row>
          <Question>TRPGライツSPLL対応の二次創作作品をAmbassで販売したいです</Question>
          <Answer>
            「TRPGライツ事務局」から公開されていてる二次創作活動のガイドラインを参照し、それらを守って販売を行ってください。作品登録の際にはSPLL申請を行い、取得したSPLL申請番号を必ず作品の説明文の末尾に「SPLL:」に続けて記載してください。
            <br />
            <StyledAnchor
              href='http://www.arclight.co.jp/trpg-rights/'
              target='_blank'
              rel='noopener noreferrer'
            >
              テーブルトークRPGに関する二次創作活動のガイドライン策定について
            </StyledAnchor>
          </Answer>
        </Row>
        <Row>
          <Question>SPLL対応の二次創作作品のライセンス料について</Question>
          <Answer>
            SPLL対応の二次創作作品の売上については、ライセンス料として売上の10%をいただきます。いただいたライセンス料は、全額をAmbassからTRPGライツ事務局へお支払いいたします。
          </Answer>
        </Row>
      </Container>
    </DefaultPageLayout>
  )
}

const Title = styled.div`
  text-align: center;
  margin: 40px 24px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const Container = styled.div`
  display: grid;
  grid-gap: 24px;
`
const Row = styled.div``
const Header = styled.div`
  margin-bottom: 4px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const Links = styled.div`
  display: grid;
  grid-gap: 8px;
`
const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.Primary};
  word-break: break-all;
`
const StyledAnchor = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.Primary};
  word-break: break-all;
`
const Question = styled.div`
  ${({ theme }) => theme.fonts.Bold14};
  color: ${({ theme }) => theme.colors.OnSurface5};
  margin-bottom: 4px;
`
const Answer = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
  margin-bottom: 8px;
`
const List = styled.ul`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const ListContainer = styled.li`
  list-style-type: lower-roman;
`
